/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdpClaimMappingDto } from './IdpClaimMappingDto';
import {
    IdpClaimMappingDtoFromJSON,
    IdpClaimMappingDtoFromJSONTyped,
    IdpClaimMappingDtoToJSON,
    IdpClaimMappingDtoToJSONTyped,
} from './IdpClaimMappingDto';

/**
 * 
 * @export
 * @interface DomainMappingDto
 */
export interface DomainMappingDto {
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    keycloakAlias?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    providerType?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof DomainMappingDto
     */
    providerConfig?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    verificationStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    primaryTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof DomainMappingDto
     */
    consentUrl?: string;
    /**
     * 
     * @type {Array<IdpClaimMappingDto>}
     * @memberof DomainMappingDto
     */
    idpClaimMappings?: Array<IdpClaimMappingDto>;
    /**
     * 
     * @type {Date}
     * @memberof DomainMappingDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DomainMappingDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof DomainMappingDto
     */
    active?: boolean;
}

/**
 * Check if a given object implements the DomainMappingDto interface.
 */
export function instanceOfDomainMappingDto(value: object): value is DomainMappingDto {
    return true;
}

export function DomainMappingDtoFromJSON(json: any): DomainMappingDto {
    return DomainMappingDtoFromJSONTyped(json, false);
}

export function DomainMappingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DomainMappingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'keycloakAlias': json['keycloakAlias'] == null ? undefined : json['keycloakAlias'],
        'providerType': json['providerType'] == null ? undefined : json['providerType'],
        'providerConfig': json['providerConfig'] == null ? undefined : json['providerConfig'],
        'verificationStatus': json['verificationStatus'] == null ? undefined : json['verificationStatus'],
        'primaryTenantId': json['primaryTenantId'] == null ? undefined : json['primaryTenantId'],
        'consentUrl': json['consentUrl'] == null ? undefined : json['consentUrl'],
        'idpClaimMappings': json['idpClaimMappings'] == null ? undefined : ((json['idpClaimMappings'] as Array<any>).map(IdpClaimMappingDtoFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function DomainMappingDtoToJSON(json: any): DomainMappingDto {
    return DomainMappingDtoToJSONTyped(json, false);
}

export function DomainMappingDtoToJSONTyped(value?: DomainMappingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'domain': value['domain'],
        'customerId': value['customerId'],
        'keycloakAlias': value['keycloakAlias'],
        'providerType': value['providerType'],
        'providerConfig': value['providerConfig'],
        'verificationStatus': value['verificationStatus'],
        'primaryTenantId': value['primaryTenantId'],
        'consentUrl': value['consentUrl'],
        'idpClaimMappings': value['idpClaimMappings'] == null ? undefined : ((value['idpClaimMappings'] as Array<any>).map(IdpClaimMappingDtoToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'active': value['active'],
    };
}

